import { Box, Strong, Text } from 'braid-design-system';

import { useAppConfig } from '../providers/AppConfigProvider';

export const PreviewBranchName = () => {
  const { environment, branchName } = useAppConfig();

  const shouldShowBanner =
    branchName && branchName !== 'master' && environment === 'staging';

  if (!shouldShowBanner) {
    return null;
  }

  return (
    <Box background="brandAccent" paddingY="small" textAlign="center">
      <Text size="small">
        You are currently previewing <Strong>{branchName}</Strong> branch.
      </Text>
    </Box>
  );
};
